export enum ImportOverviewTabs {
  LabFilesTab = 0,
  LogfileFilesTab = 1
}
